var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54 18.5201C2.93 18.5201 2.36 18.31 1.95 17.92C1.43 17.43 1.18 16.69 1.27 15.89L1.64 12.65C1.71 12.04 2.08 11.23 2.51 10.79L10.72 2.10005C12.77 -0.0699511 14.91 -0.129951 17.08 1.92005C19.25 3.97005 19.31 6.11005 17.26 8.28005L9.05 16.97C8.63 17.42 7.85 17.84 7.24 17.9401L4.02 18.49C3.85 18.5 3.7 18.5201 3.54 18.5201ZM13.93 1.91005C13.16 1.91005 12.49 2.39005 11.81 3.11005L3.6 11.8101C3.4 12.0201 3.17 12.5201 3.13 12.8101L2.76 16.05C2.72 16.38 2.8 16.65 2.98 16.82C3.16 16.99 3.43 17.05 3.76 17L6.98 16.4501C7.27 16.4001 7.75 16.14 7.95 15.93L16.16 7.24005C17.4 5.92005 17.85 4.70005 16.04 3.00005C15.24 2.23005 14.55 1.91005 13.93 1.91005Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3404 9.95005C15.3204 9.95005 15.2904 9.95005 15.2704 9.95005C12.1504 9.64005 9.64044 7.27005 9.16044 4.17005C9.10044 3.76005 9.38044 3.38005 9.79044 3.31005C10.2004 3.25005 10.5804 3.53005 10.6504 3.94005C11.0304 6.36005 12.9904 8.22005 15.4304 8.46005C15.8404 8.50005 16.1404 8.87005 16.1004 9.28005C16.0504 9.66005 15.7204 9.95005 15.3404 9.95005Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.75H1C0.59 21.75 0.25 21.41 0.25 21C0.25 20.59 0.59 20.25 1 20.25H19C19.41 20.25 19.75 20.59 19.75 21C19.75 21.41 19.41 21.75 19 21.75Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c679d791b51fe4ef809b59abf122f9b9.svg";
export { ForwardRef as ReactComponent };